const billingES = {
	title: "Facturación y Suscripción",
	loading: "Cargando...",
	errorLoading: "No se pudieron cargar los detalles de facturación en este momento.",

	currentSubscription: "Suscripción Actual",
	noSubscription: "No se encontró una suscripción.",
	startSubscription: "Comenzar suscripción",

	pricePerInterval: "{currency} {amount} / {interval}",
	nextBillingOn: "Próximo cobro: {date}",
	status: "Estado",
	billingInterval: "Cada {frequency} {interval}(s)",

	buttons: {
		updatePaymentMethod: "Actualizar método de pago",
		cancelSubscription: "Cancelar suscripción",
		manageSubscription: "Administrar suscripción",
	},

	paymentMethod: {
		title: "Método de Pago",
		noStored: "No hay método de pago guardado.",
		brand: "Marca",
		last4: "Últimos 4",
		expires: "Vence",
	},

	billingInfo: {
		title: "Información de Facturación",
		started: "Inició",
		firstBilled: "Primer cobro",
		nextBilling: "Próximo cobro",
		interval: "Intervalo",
	},

	upcomingPayment: {
		title: "Próximo Pago",
		date: "Fecha",
		subtotal: "Subtotal",
		discount: "Descuento por Referido",
		totalDue: "Total a Pagar",
	},

	transactions: {
		title: "Historial de Transacciones",
		date: "Fecha",
		invoice: "Factura",
		subtotal: "Subtotal",
		discount: "Descuento",
		total: "Total",
		status: "Estado",
		noInvoice: "—",
	},

	referralCredits: {
		title: "Créditos por Referidos",
		availableCredit: "crédito disponible",
		creditBalance: "Saldo de Crédito",
		rewardsEarned: "Recompensas obtenidas",
		referral: "referido",
		referrals: "referidos",
		usedCode: "Código Usado",
		code: "Código",
		status: "Estado",
		shopsReferred: "Negocios que Referiste",
		rewarded: "Recompensado",
		statusLabels: {
			pending_billing: "Esperando primer pago",
			pending_referrer_payment: "Esperando el primer pago del referidor",
			reward_issued: "Descuento aplicado ✓",
		},
	},

	discount: {
		active: "🎉 Descuento por referido activo",
		appliedRange: "Aplicado {from} → {to}",
	},

	plans: {
		title: "Planes Disponibles",
		options: "{count} opciones",
		choosePlan: "Elegir plan",
	},

	seats: {
		activeSeats: "{count} asiento(s) activo(s)",
		seatPricing: "{currency} {amount} por asiento / mes",
		total: "Total facturado: {currency} {total}",
	},

	statusBadge: {
		active: "Activo",
		canceled: "Cancelado",
		paused: "Pausado",
		trialing: "En prueba",
		past_due: "Vencido",
		unpaid: "Sin pagar",
		incomplete: "Incompleto",
		incomplete_expired: "Expirado",
		completed: "Completado",
		paid: "Pagado",
		pending: "Pendiente",
	},

	referral: {
		title: "Programa de Referidos",
		loading: "Cargando...",
		noCode: "Aún no tienes un código de referido.",
		generate: "Generar Código de Referido",
		codeLabel: "Tu Código:",
		copyCode: "Copiar Código",
		copyLink: "Copiar",
		copied: "Copiado al portapapeles",
		linkCopied: "¡Enlace copiado!",
		linkLabel: "Enlace de Referido",
		historyTitle: "Historial de Referidos",
		noReferrals: "Aún no tienes referidos.",
		defaultShopName: "Nuevo Negocio",
		applyTitle: "Código de Referido",
		applyPlaceholder: "Ingresa el código de referido",
		applyButton: "Aplicar",
		applyLoading: "...",
		usingCode: "Usando código:",
		applied: "Código de referido aplicado",
		status: {
			pending: "Pendiente",
			active: "Activo",
			converted: "Convertido",
		},
	},
	misc: {
		month: "mes",
	},
};

export default billingES;
